import assertNever from 'assert-never';

import { CloudGatewayDiscoveryStatus } from '@shure/cloud/shared/models/devices';

import { CloudGatewayDeviceDiscoveryStatus } from '../graphql/generated/cloud-sys-api';

export function mapCloudGatewayDiscoveryStatusFromSysApi(
	status: CloudGatewayDeviceDiscoveryStatus
): CloudGatewayDiscoveryStatus {
	switch (status) {
		case CloudGatewayDeviceDiscoveryStatus.DeviceBusy:
			return CloudGatewayDiscoveryStatus.DeviceBusy;
		case CloudGatewayDeviceDiscoveryStatus.DeviceNotFound:
			return CloudGatewayDiscoveryStatus.DeviceNotFound;
		case CloudGatewayDeviceDiscoveryStatus.DeviceUnavailable:
			return CloudGatewayDiscoveryStatus.DeviceUnavailable;
		case CloudGatewayDeviceDiscoveryStatus.DiscoveryComplete:
			return CloudGatewayDiscoveryStatus.Complete;
		case CloudGatewayDeviceDiscoveryStatus.Failure:
			return CloudGatewayDiscoveryStatus.Failure;
		default:
			assertNever(status);
	}
}
